import React from 'react'
import styles from './Desc.module.scss'
import { motion } from 'framer-motion'

const Desc = () => {

    const marqueeVariants = {
        animate: {
            x: [0, -window.innerWidth * 2],
            transition: {
                x: {
                    repeat: Infinity,
                    repeatType: "loop",
                    duration: 40,
                    ease: "linear",
                },
            },
        },
    };

    return (
        <div className={styles.desc}>

            <div className={styles.marquee}>
                <motion.div
                    className={styles.track}
                    variants={marqueeVariants}
                    animate="animate"
                >
                    <h1>NFT Dashbo, Payyd, AI Tutor, DirectPay, Crypto Clash, Spelendid Accounts, Factory, Yuga Dashbo, Apelyze, ImmiFellow</h1>
                </motion.div>
            </div>

            <div className={styles.textContainer}>
                <div className={styles.textContainer2}>
                    <h3>Open to <span>Job Opportunities</span> world wide.<span>Passionate</span> about <span>Web Development</span>, <span>Blockchain</span>, <span>Web3</span>, and <span>AI</span> products<span>.</span></h3>
                </div>
            </div>

        </div>
    )
}

export default Desc